import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M18 10.82a1 1 0 0 0-1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1 1 0 0 0-1-1m3.92-8.2a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.59L8.29 14.29a1 1 0 0 0-.2958.71 1 1 0 0 0 .2958.71 1 1 0 0 0 .71.2958 1 1 0 0 0 .71-.2958L20 5.41V9a1.0002 1.0002 0 0 0 1.7071.7071A1 1 0 0 0 22 9V3a1 1 0 0 0-.08-.38"
}), "ExternalLink", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
